import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OrderCollection } from 'src/models/DTO/V2/orders/OrderCollection';
import { OrderResponse } from 'src/models/DTO/V2/orders/OrderResponse';
import { ConfirmOrder } from 'src/models/requestModels/V2/orders/confirmOrder';
import { CancelOrder } from 'src/models/requestModels/V2/orders/cancelOrder';
import { RefundOrder } from 'src/models/requestModels/V2/orders/refundOrder';
import { CancelOrderLine } from 'src/models/requestModels/V2/orders/cancelOrderLine';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private orderURL: string = environment.api + 'order';
  private orderReturnURL: string = environment.api + 'order/return/';
  private cancelOrderURL: string = environment.api + 'order/cancel';
  private cancelOrderLineURL: string = environment.api + 'order/line/cancel';
  private confirmOrderURL: string = environment.api + 'order/confirm';
  private searchOrderURL: string = environment.api + 'order/search';
  private refundOrderURL: string = environment.api + 'order/refund';
  private confirmReturnURL: string = environment.api + 'order/return/confirm';
  private cancelReturnURL: string = environment.api + 'order/return/cancel';

  constructor(private httpClient: HttpClient) {}

  getOrdersForPartner(perPage: number, page: number, state: string = 'all'): Observable<OrderCollection> {
    let params = '?include=user,delivery_address,invoice_address,group,lines,shipment,paymentMethod&perPage=' + perPage + '&page=' + page;
    if (state !== 'all') {
      params += '&filter%5Bstate%5D=' + state;
    }
    return this.httpClient.get<OrderCollection>(this.searchOrderURL + params);
  }

  search(
    perPage: number,
    page: number,
    state: string = 'all',
    query: string,
    sort: string = '',
    filters: Array<any> = []
  ): Observable<OrderCollection> {
    let params = '?sort=' + sort + '&include=orderReturn,orderReturn.items,orderReturn.items.orderLine,organisationFees,user,delivery_address,invoice_address,group,lines,shipment,lines.sku,paymentMethod&perPage=' + perPage + '&page=' + page + '&q=' + query;
    const queryFilters = filters;

    if (state !== 'all') {
      queryFilters.push({ filter: 'state', value: state });
      params += '&filter%5Bstate%5D=' + state;
    }

    queryFilters.forEach(filter => {
      if (filter.filter !== 'state') {
        params += '&filter%5B' + filter.filter + '%5D=' + filter.value;
      }
    });

    return this.httpClient.get<OrderCollection>(this.searchOrderURL + params);
  }

  getOrder(orderUUID: string): Observable<OrderResponse> {
    const params = '/' + orderUUID + '?include=orderReturn,orderReturn.items,orderReturn.items.orderLine,organisation_fees,lines.sku.options.option,lines.sku.options.option.values,payment_method,user,delivery_address,invoice_address,group,lines,shipment,lines.sku,lines.sku.product,lines.sku.product.organisation,lines.sku.product.pricing';
    return this.httpClient.get<OrderResponse>(this.orderURL + params);
  }

  cancelOrder(orderUUID: string, cancelOrderModel: CancelOrder): Observable<any> {
    const params = '/' + orderUUID;
    return this.httpClient.post<any>(this.cancelOrderURL + params, cancelOrderModel);
  }

  confirmOrder(orderUUID: string, confirmOrderRequestModel: ConfirmOrder): Observable<any> {
    const params = '/' + orderUUID;
    return this.httpClient.post<any>(this.confirmOrderURL + params, confirmOrderRequestModel);
  }

  cancelOrderLine(orderLineUUID: string, cancelOrderLine: CancelOrderLine): Observable<any> {
    const params = '/' + orderLineUUID;
    return this.httpClient.post<any>(this.cancelOrderLineURL + params, cancelOrderLine);
  }

  downloadOrderDocument(orderUUID: string): Observable<Blob> {
    const params = '/' + orderUUID + '/download-document';
    return this.httpClient.get(this.orderURL + params, {
      headers: { 'content-type': 'application/download' },
      responseType: 'blob'
    });
  }

  refundOrder(orderUUID: string, refundOrder: RefundOrder): Observable<any> {
    const param = '/' + orderUUID;
    return this.httpClient.post<any>(this.refundOrderURL + param, refundOrder);
  }

  confirmReturn(orderReturnUUID: string, amountRefunded: number): Observable<any> {
    const param = '/' + orderReturnUUID;
    return this.httpClient.post<any>(this.confirmReturnURL + param, {amount_refunded: amountRefunded});
  }

  cancelReturn(orderReturnUUID: string): Observable<any> {
    const param = '/' + orderReturnUUID;
    return this.httpClient.post<any>(this.cancelReturnURL + param, null);
  }
}
